module.exports = __webpack_public_path__ + "img/tooltip_litho-board-2.742e722c.jpg";